import { createReducer } from '@reduxjs/toolkit';
import { ICommonState } from 'app/interfaces/reducer-interface/common.interface';
import {
	setNewPasswordAction,
	ISetNewPasswordRequest,
	setErrorChangePasswordAction,
	setChangePasswordSuccesAction,
	setResetErrorAndMessageAction,
} from '../actions/ChangePasswordAction';

interface IChangePasswordState extends ICommonState {
	request: ISetNewPasswordRequest;
}

const request: ISetNewPasswordRequest = {
	oldPassword: '',
	newPassword: '',
	confirmNewPassword: '',
};

const initialState: IChangePasswordState = {
	loading: false,
	request,
	message: '',
	error: '',
};

const changePasswordReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(setNewPasswordAction, (state, action) => ({
			...state,
			request: action.payload,
		}))
		.addCase(setChangePasswordSuccesAction, (state, action) => ({
			...state,
			message: action.payload,
		}))
		.addCase(setErrorChangePasswordAction, (state, action) => ({
			...state,
			error: action.payload,
		}))
		.addCase(setResetErrorAndMessageAction, (state) => ({
			...state,
			error: '',
			message: '',
		}))
		.addDefaultCase((state) => ({ ...state }));
});

export default changePasswordReducer;
